import React, { useContext } from 'react'
import { dateCol, intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { getBidOffer } from '../api/pgads'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  isValidYearRange,
} from 'core'
import { connect } from 'react-redux'
import { DatePicker } from 'antd'
import { DatePickerContext, PNodeZoneContext } from 'context'
import {
  //  modifiedDateCol,
  // modifierCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

const title = 'Bid Offer'

const BidOffer = () => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const {
    unitIdEmktIdMap,
    emktIdUnitNameMap,
    // marginUnitsList,
    emktUnits,
  } = useContext(PNodeZoneContext)

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId).map(id => unitIdEmktIdMap[id]),
    startdate: selectedDateRangePicker[0],
    enddate: selectedDateRangePicker[1],
  })

  const extraUnitSelectionProps = _ => ({
    limitedUnits: emktUnits,
    units: emktUnits,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = OaBidOfferHeaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      extraUnitSelectionProps={extraUnitSelectionProps}
      screenCriteria={screenCriteria}
      withCriteria={withCriteria}
      withUnitSelection
      isAdminScreen={false}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getBidOffer}
      altBy={d => d.unitid}
      autoRetrieve={false}
      sortOptions={OaBidOfferHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => _}
      allowInsert={false}
      withoutModify
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(BidOffer)

export const OaBidOfferHeaders = [
  // strCol({ ident: 'companyId', display: 'CompanyId', isFiltered: true }),
  // strCol({ ident: 'unitid', display: 'Unit', isKey: true }),
  unitIdHeader,
  dateCol({
    ident: 'transdate',
    display: 'Transaction Date',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),

  intCol({
    ident: 'schedule',
    display: 'Schedule',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'slope',
    display: 'Use Bid Slope',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'mw',
    display: 'Segment EndMW',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'price',
    display: 'Offer Price',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'modifier',
    display: 'Modifier',
    showInRowEditor: false,
    type: 'str',
    width: 130,
    isKey: true,
  }),
  {
    ident: 'modifiedDate',
    display: 'Modified Date',
    width: 200,
    showInRowEditor: false,
    dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
    displayFormat: 'MM/DD/YYYY HH:mm:SS',
    type: 'date-time',
    isKey: true,
  },
]
